import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAPIURL, getFormattedPrice } from "../../services/helper";
import http from "../../services/http";
import { Spinner, Container, Button } from "reactstrap";
import DataTable from "react-data-table-component";
import { useDispatch } from "react-redux";
import { openView } from "../../ReduxToolkit/Reducers/viewReducer";
import InvoiceModal from "./components/InvoiceModal";
import { handlePrinting } from "../../Utils/PrintingCart";

const CloseReportDetails = ({ register_id }) => {
  // const { register_id } = useParams(); // Get register ID from URL
  const api_url = getAPIURL();
  const [transactions, setTransactions] = useState([]);
  const [registerInfo, setRegisterInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewModal, setViewModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchRegisterReport();
  }, []);

  const fetchRegisterReport = async () => {
    setLoading(true);
    try {
      const { data } = await http.get(
        `${api_url}/reports/close/detail/${register_id}`
      );
      setTransactions(data.transactions || []);
      setRegisterInfo(data.register_info || null);
    } catch (error) {
      console.error("Error fetching register report:", error);
    }
    setLoading(false);
  };

  const columns = [
    { name: "Order ID", selector: (row) => row.order_id, sortable: true },
    { name: "Order Date", selector: (row) => row.order_date, sortable: true },
    {
      name: "Total",
      selector: (row) => `$${row.order_total}`,
      sortable: true,
    },
    {
      name: "Tendered",
      selector: (row) => `$${row.amount_paid}`,
      sortable: true,
    },
    {
      name: "Change Given",
      selector: (row) => `$${row.change_given}`,
      sortable: true,
    },
    {
      name: "Payment Type",
      cell: (row) => {
        if (row.split_payment?.payments) {
          return row.split_payment.payments.map(p => p.type).join(", ");
        }
        return "-";
      },
    },
    {
      name: "Tax Collected",
      selector: (row) => `$${row.tax_collected || 0}`,
      sortable: true,
    },
    {
      name: "Discounts",
      selector: (row) => `$${row.discount || 0}`,
      sortable: true,
    },
    {
      name: "Refund",
      cell: (row) => (
        <span style={{ color: row.refund_amount > 0 ? "red" : "inherit" }}>
          {row.refund_amount > 0 ? getFormattedPrice(row.refund_amount) : "-"}
        </span>
      ),
      sortable: true,
    },
  ];

  return (
    <div className="page-body">
      <Container className="mt-2">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="mb-1">Register #{register_id}</h4>
            {registerInfo && (
              <small className="text-muted">
                {registerInfo.cashier && <span>Cashier: {registerInfo.cashier} | </span>}
                {registerInfo.opened_at && <span>Opened: {registerInfo.opened_at} | </span>}
                {registerInfo.closed_at && <span>Closed: {registerInfo.closed_at}</span>}
              </small>
            )}
          </div>
          <Button color="primary" onClick={() => dispatch(openView("reports_close"))}>
            Back
          </Button>
        </div>
        {loading ? (
          <div className="text-center">
            <Spinner color="primary" size="lg" />
            <p>Loading Transactions...</p>
          </div>
        ) : transactions.length > 0 ? (
          <DataTable
            columns={columns}
            data={transactions}
            pagination
            striped
            highlightOnHover
            onRowClicked={(row) => {
              setSelectedOrder(row);
              setViewModal(true);
            }}
            pointerOnHover
          />
        ) : (
          <p className="text-center">No transactions found.</p>
        )}

        {!loading && transactions.length > 0 && (
          <div className="d-flex justify-content-end gap-4 p-3" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
            <span><strong>Total:</strong> {getFormattedPrice(transactions.reduce((sum, t) => sum + parseFloat(t.order_total || 0), 0))}</span>
            <span><strong>Tendered:</strong> {getFormattedPrice(transactions.reduce((sum, t) => sum + parseFloat(t.amount_paid || 0), 0))}</span>
            <span><strong>Change:</strong> {getFormattedPrice(transactions.reduce((sum, t) => sum + parseFloat(t.change_given || 0), 0))}</span>
            <span><strong>Tax:</strong> {getFormattedPrice(transactions.reduce((sum, t) => sum + parseFloat(t.tax_collected || 0), 0))}</span>
            <span><strong>Discount:</strong> {getFormattedPrice(transactions.reduce((sum, t) => sum + parseFloat(t.discount || 0), 0))}</span>
            <span style={{ color: "red" }}><strong>Refund:</strong> {getFormattedPrice(transactions.reduce((sum, t) => sum + parseFloat(t.refund_amount || 0), 0))}</span>
          </div>
        )}

        <InvoiceModal
          isOpen={viewModal}
          toggle={() => setViewModal(false)}
          selectedOrder={selectedOrder}
          onPrintReceipt={(row) => handlePrinting(row, { receipt: true, label: false })}
          onPrintLabel={(row) => handlePrinting(row, { receipt: false, label: true })}
          onRefund={fetchRegisterReport}
          onDelete={() => {}}
        />
      </Container>
    </div>
  );
};

export default CloseReportDetails;
